var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvasContainer",staticClass:"canvasContainer",class:{ 'is-pan': _vm.panCursor }})
}
var staticRenderFns = []

export { render, staticRenderFns }